import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemText, makeStyles } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { InfoCard, EmptyState } from '@backstage/core-components';
import { EntityRefLink, useEntity } from '@backstage/plugin-catalog-react';

export const LEAD_DEVELOPER_ANNOTATION = 'itkom.pbs.ch/lead-developer';

const useStyles = makeStyles(theme => ({
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: 32,
        height: 32,
    },
    avatarIcon: {
        fontSize: '1rem',
    },
    listItem: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    list: {
        paddingTop: 0,
    },
}));

export const LeadDevelopersCard = () => {
    const classes = useStyles();
    const { entity } = useEntity();

    const annotation = entity.metadata.annotations?.[LEAD_DEVELOPER_ANNOTATION];

    const leadDevelopers = annotation
        ? annotation.split(',').map(ref => ref.trim()).filter(Boolean)
        : [];

    if (leadDevelopers.length === 0) {
        return (
            <InfoCard title="Lead Developers">
                <EmptyState
                    missing="data"
                    title="No lead developers defined"
                    description={`Add the "${LEAD_DEVELOPER_ANNOTATION}" annotation to define lead developers.`}
                />
            </InfoCard>
        );
    }

    return (
        <InfoCard title="Lead Developers">
            <Box>
                <List dense className={classes.list}>
                    {leadDevelopers.map(ref => (
                        <ListItem key={ref} className={classes.listItem}>
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <PersonIcon className={classes.avatarIcon} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <EntityRefLink entityRef={ref} />
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </InfoCard>
    );
};
